import React from 'react'
import { bindActionCreators } from 'redux'
import { polyglotActions } from '../../redux/polyglot'
import { authActions } from '../../redux/auth'
import Main from './Main'
import { connect } from 'react-redux'
import { getLocale } from '../../resources/translations'
import {polyglot as polyglotInstance} from '../../index'
import MedicalStaff from '../../models/MedicalStaff/MedicalStaff'
import v4 from 'uuid/v4'

function getMedicalStaff (profile) {
  const name = profile.name.toString().includes('@') ? `${(profile.user_metadata && profile.user_metadata.firstName) || 'Paulo'} ${(profile.user_metadata && profile.user_metadata.lastName) || 'Gomes'}` : profile.name
  return new MedicalStaff(
    v4(),
    name,
    profile.picture,
    profile.gender || (profile.user_metadata && profile.user_metadata.gender) || '',
    (profile.user_metadata && profile.user_metadata.profession) || '',
    '1234ABF331',
    (profile.user_metadata && profile.user_metadata.location) || '',
    '+55 11 2395 8400',
    '+55 923 958 400',
    profile.email
  )
}

class MainContainer extends React.Component {
  componentDidMount () {
    if (!this.props.hasTranslations) {
      this.props.replaceTranslations(getLocale())
    } else {
      this.props.setTranslations(this.props.locale)
    }
  }

  render () {
    const {match, polyglotReady, ...passThroughProps} = this.props
    const {profile} = passThroughProps
    if (polyglotReady && profile) {
      return <Main match={match} doctorProfile={getMedicalStaff(profile)} {...passThroughProps} />
    } else {
      return <div>Loading</div>
    }
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({...polyglotActions, ...authActions}, dispatch)
}

function mapStateToProps ({polyglot, auth}) {
  return {
    profile: auth.profile,
    locale: polyglot.locale,
    hasTranslations: polyglot.hasTranslations,
    polyglotReady: polyglot && Object.keys(polyglotInstance.phrases).length > 0
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer)
